import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { "data-cy": "settlement-complete-panel" }
const _hoisted_2 = { class: "cp-card" }
const _hoisted_3 = { class: "done-hero" }
const _hoisted_4 = { class: "done-hero-main" }
const _hoisted_5 = {
  key: 0,
  class: "done-sub"
}
const _hoisted_6 = { class: "done-hero-actions" }
const _hoisted_7 = { class: "cp-unlock-tooltip" }
const _hoisted_8 = { class: "psa-docs" }
const _hoisted_9 = ["href"]

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import AlertBar from '@/components/AlertBar.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import { formatLongDateString } from '@/services/utils';
import { useSettlementStore } from '@/modules/matters/settlement/stores/useSettlementStore';
import SettlementDisbursementTable from './SettlementDisbursementTable.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettlementCompletePanel',
  props: {
  generatedDate: { type: String, default: null },
  downloadUrl: { type: String, default: null },
  canReset: { type: Boolean, default: true },
  resetBlockedReason: { type: String, default: null },
  invoiceFinalized: { type: Boolean, default: false },
  trustStatementLoading: { type: Boolean, default: false },
},
  emits: ['unlock-and-reset', 'download', 'download-trust-statement', 'view-invoice'],
  setup(__props) {

const props = __props;



const { disbursements } = storeToRefs(useSettlementStore());
const negativeNet = computed(() => !!disbursements.value.data?.clientNetNegative);

const generatedDateFormatted = computed(() =>
  props.generatedDate
    ? formatLongDateString(props.generatedDate) || props.generatedDate
    : '',
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (negativeNet.value)
      ? (_openBlock(), _createBlock(AlertBar, {
          key: 0,
          type: "error",
          class: "mb-4",
          "data-cy": "disb-negative-warning"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "cp-warn-title" }, "Client Net Proceeds Are Negative", -1),
            _createElementVNode("p", { class: "cp-warn-body" }, " Fees, expenses, and liens exceed the settlement amount. Please review the settlement breakdown before distributing funds. ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "done-check",
          "aria-hidden": "true"
        }, [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            class: "done-ic"
          }, [
            _createElementVNode("path", {
              d: "M20 6L9 17l-5-5",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "2.6",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "done-title" }, "Settlement Complete", -1)),
            (generatedDateFormatted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Generated " + _toDisplayString(generatedDateFormatted.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (__props.canReset)
              ? (_openBlock(), _createBlock(LlSecondaryButton, {
                  key: 0,
                  variant: "text",
                  color: "error",
                  size: "small",
                  class: "cp-unlock",
                  "prepend-icon": "mdi-lock-open-outline",
                  "data-cy": "unlock-reset-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unlock-and-reset')))
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Unlock & Reset ", -1)
                  ]))]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(LlTooltip, {
                  key: 1,
                  location: "bottom"
                }, {
                  activator: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(LlSecondaryButton, {
                        variant: "text",
                        size: "small",
                        class: "cp-unlock",
                        "prepend-icon": "mdi-lock",
                        disabled: "",
                        "data-cy": "unlock-reset-button-blocked"
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode(" Unlock & Reset ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(__props.resetBlockedReason || 'Reset is not available right now.'), 1)
                  ]),
                  _: 1
                }))
          ])
        ])
      ]),
      _createVNode(SettlementDisbursementTable),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          class: _normalizeClass(["psa-doc", { 'psa-doc--disabled': !__props.downloadUrl }]),
          href: __props.downloadUrl || undefined,
          download: "settlement-statement.pdf",
          "data-cy": "settlement-statement-link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.downloadUrl && _ctx.$emit('download')))
        }, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("span", {
            class: "icon icon-doc",
            "aria-hidden": "true"
          }, [
            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
              _createElementVNode("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zM13 9V3.5L18.5 9H13z" })
            ])
          ], -1),
          _createTextVNode(" Settlement Statement ", -1)
        ]))], 10, _hoisted_9),
        (__props.invoiceFinalized)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "psa-doc",
              "data-cy": "view-invoice-link",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('view-invoice')), ["prevent"]))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("span", {
                class: "icon icon-doc",
                "aria-hidden": "true"
              }, [
                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                  _createElementVNode("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zM13 9V3.5L18.5 9H13z" })
                ])
              ], -1),
              _createTextVNode(" View Invoice ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (__props.invoiceFinalized)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: _normalizeClass(["psa-doc", { 'psa-doc--disabled': __props.trustStatementLoading }]),
              "data-cy": "trust-statement-link",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (!__props.trustStatementLoading && _ctx.$emit('download-trust-statement')), ["prevent"]))
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("span", {
                class: "icon icon-doc",
                "aria-hidden": "true"
              }, [
                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                  _createElementVNode("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zM13 9V3.5L18.5 9H13z" })
                ])
              ], -1)),
              _createTextVNode(" " + _toDisplayString(__props.trustStatementLoading ? 'Downloading Trust Statement…' : 'Trust Statement') + " ", 1),
              _createVNode(LlTooltip, { location: "top" }, {
                activator: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("span", {
                    class: "info-dot",
                    tabindex: "0"
                  }, "i", -1)
                ]))]),
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"max-width":"260px"} }, " A summary of all trust account activity associated with this settlement: deposits, disbursements, lien payoffs, and payments. ", -1))
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})